import copy from 'clipboard-copy'

export const copyToClipboard = (value) => {
    copy(value)
}
